// **  Initial State
const initialState = {
  userData: {},
};

const authReducer = (state = initialState, action) => {
  switch (action.type) {
    case "CHECK_STATUS":
      return {
        ...state,
        statusCheck: action.payload,
      };

    case "LOGIN":
      return {
        ...state,
        userData: action.data,
      };

    case "ADD_EMAIL_DATA":
      return {
        ...state,
        userData: action.payload,
      };

    case "SET_EMAIL_SUCCESS":
      return {
        ...state,
        emailSuccess: action.payload,
        emailFlag: true,
      };

    case "SET_EMAIL_FAILED":
      return {
        ...state,
        emailFailed: action.payload,
        emailFlag: false,
      };

    case "LOGOUT":
      const obj = { ...action };
      delete obj.type;
      return { ...state, userData: {}, ...obj };

    default:
      return state;
  }
};

export default authReducer;
